import { render, staticRenderFns } from "./deadline.vue?vue&type=template&id=d808b03c&scoped=true&"
import script from "./deadline.vue?vue&type=script&lang=js&"
export * from "./deadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d808b03c",
  null
  
)

export default component.exports